import { Badge } from "@/components/ui/badge";

export const TypeBadge = ({ type }: { type: string }) => {
	const normalizedType = type.toUpperCase();

	const typeStyles = {
		ORDER: "bg-green-500 text-black",
		QUOTE: "bg-orange-400 text-black",
		REQUEST: "bg-blue-500 text-white",
	};

	return (
		<Badge
			className={
				typeStyles[normalizedType as keyof typeof typeStyles] ??
				"bg-slate-200 text-slate-800"
			}
		>
			{normalizedType}
		</Badge>
	);
};
